/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiASkipForwardIcon24Solid = forwardRef('MediaUiASkipForwardIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M17 13.532V18.5a1.5 1.5 0 1 0 3 0v-13a1.5 1.5 0 0 0-3 0v4.968L6.664 4.133C5.498 3.418 4 4.257 4 5.625v12.75c0 1.367 1.498 2.207 2.664 1.492L17 13.532Z" })));
});
